"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.POINT_FRAGMENT = void 0;
var client_1 = require("@apollo/client");
exports.POINT_FRAGMENT = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment Point on Point {\n    x\n    y\n    z\n  }\n"], ["\n  fragment Point on Point {\n    x\n    y\n    z\n  }\n"])));
var templateObject_1;
